export default __webpack_public_path__ + "static/AtightlyguardedHimalayansecret-5314f11a79cb841a954ca72e072b57f3.jpg";